export const brandCaptionLowerThirdIsInUse = {
  type: "boolean"
};
